// Define UserRole enum in a separate file for server-side compatibility
export const UserRole = {
  ADMIN: 'ADMIN',
  EDITOR: 'EDITOR',
  AGENT: 'AGENT',
  SUPERVISOR: 'SUPERVISOR',
  SUPERADMIN: 'SUPERADMIN',
} as const

export type UserRole = (typeof UserRole)[keyof typeof UserRole]
